import {
  GET_SCHOOL_SUBSIDY_ORDERS_SETTINGS_APPLY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/subsidy_orders_settings_apply/get'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import {
  SubsidyOrdersSettingsApplyResult,
  SubsidyOrdersSettingsStatusParams,
} from 'app/common/types/food/schools/subsidyOrdersSettingsApply'

const defaultState = { running: true }

type Options = CommonDataOptions<
  SubsidyOrdersSettingsApplyResult,
  SubsidyOrdersSettingsStatusParams
>

export function useSubsidyOrdersSettingsStatus(options: Options = {} as Options) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_SCHOOL_SUBSIDY_ORDERS_SETTINGS_APPLY,
    error: 'Не удалось получить статус применения настроек справок о льготах к текущим справкам',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
